module.exports = __webpack_public_path__ + "img/ebay.b316969d.png";